import getConfig from 'next/config';

import { fechFromBPartsApi } from '../utils';
import { IncomingMessage } from 'http';

const { serverRuntimeConfig } = getConfig();

export const fetchLanguages = (
  {
    locale,
  }: {
    locale: string;
  },
  req?: IncomingMessage
): Promise<Languages> =>
  fechFromBPartsApi(`/${locale}/shop/languages`, {
    credentials: 'include',
    headers: req ? new Headers(req.headers as HeadersInit) : undefined,
  }).then((value) => value.json());
